/** A failed clipboard operation must never be presented as successful. */
export async function tryCopyText(value: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(value); return true }
  } catch { /* attempt a legacy browser fallback */ }
  const input = document.createElement('textarea')
  input.value = value
  input.setAttribute('readonly', '')
  input.style.position = 'fixed'
  input.style.left = '-9999px'
  const focused = document.activeElement as HTMLElement | null
  document.body.appendChild(input)
  try {
    input.select()
    return typeof document.execCommand === 'function' && document.execCommand('copy')
  } catch { return false }
  finally { input.remove(); focused?.focus() }
}
